"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_1 = require("./base");
var MaterialClient = /** @class */ (function (_super) {
    __extends(MaterialClient, _super);
    function MaterialClient(debug, materialConfig) {
        if (debug === void 0) { debug = true; }
        var _this = _super.call(this) || this;
        _this.materialUrl = materialConfig.url;
        return _this;
    }
    /**
     * 获取上传token
     * @param source 来源
     * @param isPrivate 是否私有空间，0 = 公共空间  1 = 私有空间
     */
    MaterialClient.prototype.getUploadToken = function (source, isPrivate) {
        if (isPrivate === void 0) { isPrivate = 0; }
        return this.get(this
            .materialUrl + "QiNiu/upload/getToken?source=" + source + "&isPrivate=" + isPrivate);
    };
    return MaterialClient;
}(base_1.BaseClient));
exports.MaterialClient = MaterialClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF0ZXJpYWwtY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudHMvbWF0ZXJpYWwtY2xpZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUNBLCtCQUFvQztBQUVwQztJQUFvQyxrQ0FBVTtJQUc1Qyx3QkFBWSxLQUFxQixFQUFFLGNBQStCO1FBQXRELHNCQUFBLEVBQUEsWUFBcUI7UUFBakMsWUFDRSxpQkFBTyxTQUVSO1FBREMsS0FBSSxDQUFDLFdBQVcsR0FBRyxjQUFjLENBQUMsR0FBRyxDQUFDOztJQUN4QyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLHVDQUFjLEdBQXJCLFVBQXNCLE1BQWMsRUFBRSxTQUFxQjtRQUFyQiwwQkFBQSxFQUFBLGFBQXFCO1FBQ3pELE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUNWLElBQUk7YUFDSixXQUFXLHFDQUFnQyxNQUFNLG1CQUFjLFNBQVcsQ0FDOUUsQ0FBQztJQUNKLENBQUM7SUFDSCxxQkFBQztBQUFELENBQUMsQUFuQkQsQ0FBb0MsaUJBQVUsR0FtQjdDO0FBbkJZLHdDQUFjIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/material-client.js
// module id = 201
// module chunks = 44